<li class="prf-small-info-block" [ngClass]="infoBlockItem.theme">
  <prf-h3 class="prf-small-info-block-title">{{ infoBlockItem.title }}</prf-h3>
  <p class="prf-small-info-block-description">{{ infoBlockItem.description }}</p>
</li>
